<template>
  <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    :return-value.sync="selectedDate"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        v-on="on"
        v-model="selectedDate"
        :label="label"
        :rules="rules.selectedDate"
        prepend-inner-icon="mdi-calendar-blank-outline"
        filled
        readonly
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="selectedDate"
      :min="minDate"
      v-bind="$attrs"
      @input="$emit('input', datePickerToIso(selectedDate)) && $refs.menu.save(selectedDate)"
    >
    </v-date-picker>
  </v-menu>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    label: {
      type: String,
      default: 'วันที่',
    },
    value: null,
    min: null,
  },
  watch: {
    date(newVal) {
      this.selectedDate = this.isoToDatePicker(newVal);
    },
    min(newVal) {
      this.minDate = this.isoToDatePicker(newVal);
    },
    value(newVal) {
      this.selectedDate = this.isoToDatePicker(newVal);
    },
  },
  data() {
    return {
      selectedDate: this.isoToDatePicker(this.value),
      minDate: this.isoToDatePicker(this.min),
      menu: false,
      rules: {
        selectedDate: [
          v => !!v || 'กรุณาเลือก วันที่นัด',
        ],
      },
    };
  },
  methods: {
    isoToDatePicker(iso) {
      if (iso) {
        return moment(iso).local().format('YYYY-MM-DD');
      }
      return null;
    },
    datePickerToIso(time) {
      return moment(time).local().format('YYYY-MM-DDTHH:mm:ssZ');
    },
  },
};
</script>
